import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/pages/auth/auth.context";
import { Loader } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { token, loading } = useAuth();
  const location = useLocation();

  // Show loading indicator while auth state is being determined
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <Loader className="h-8 w-8 animate-spin text-foreground" />
          <p className="text-foreground">Loading authentication...</p>
        </div>
      </div>
    );
  }

  if (!token) {
    // Encode the full path (including search params and hash) as a URL parameter
    const redirectTo = encodeURIComponent(
      location.pathname + location.search + location.hash,
    );
    return <Navigate to={`/signin?redirect=${redirectTo}`} replace />;
  }

  return <>{children}</>;
};
